import(/* webpackMode: "eager" */ "/app/apps/copilot/app/global-error.tsx");
